import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { fetchAcademyMe } from "@/api/academyAuth";

export default function AcademyProtectedRoute({ children }) {
  const [ok, setOk] = useState(null);

  useEffect(() => {
    fetchAcademyMe()
      .then(() => setOk(true))
      .catch(() => setOk(false));
  }, []);

  if (ok === null) return null;
  if (!ok) return <Navigate to="/academy-login" replace />;

  return children;
}
